<template>
  <div class="involvement-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <line-chart
      v-if="isLoaded"
      :chart-data="dataLineCollection"
      :options="lineOptions"
      class="involvement-content__chart"
      :height="350"
    ></line-chart>

    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { LineChart } from "../../../../../../../../components/charts";

  // mixins
  import involvement from "../../../../../../../../mixins/chart/involvement";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import age from "../../../../../../../../config/age";

  // moment
  import moment from 'moment';

  export default {
    name: "InvolvementBody",
    props: {
      data: {
        type: Object,
        required: true
      },
      chartName: {
        type: String
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        age: age,
        chartId: "Involvement",
        format: "DD.MM.YYYY",
      }
    },
    computed: {
      chartDate() {
        return this.$store.getters.getAuditPeriod(this.chartName);
      },
      isLoaded() {
        return this.$store.getters.isAuditLoaded(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
    },
    mixins: [
      involvement,
      saveImage
    ],
    components: {
      LineChart
    }
  };
</script>

<style>
  @import "../../../../../../../../style/tonal.css";
  .involvement-content__chart {
    margin-bottom: 10px;
  }
</style>
